/*
* Report page
*/

import * as React from 'react';
import ReactImageFallback from 'react-image-fallback';

import { Formatters } from '../../../common/formatters';
import ApiEndpoints from '../../../config/apiendpoints';
import * as OrderCommon from '../../order-common';
import * as BidLetterReportComponents from '../report-components';
import stringtemplate from 'string-template';

export const Render = ({ reportData, ...rest }) => {
    const { currentOrder, branding, association, associationClient, orderClient, pricingMatrix, orderServicesPricingMatrix, serviceLevels, orderManagerUser, bidLetterTextContents, ...otherReportData } = reportData;

    const orderClientStateCode = Formatters.getStr(currentOrder, 'association.client.location.stateCode');
    const orderAssocCompanyBrandKey = Formatters.getStr(currentOrder, 'company.brandKey');

    const southernNevadaStringObj = {
        text:
            `<h2>Complex Solutions Ltd.</h2>
        <p style="font-size:120%;">Complex Solutions was started in 2001 by Robert Forney. Complex Solutions provides reserve
        study consulting services to clients primarily in Nevada, California and Utah. Mr. Forney holds a
        Bachelor of Science degree in Business Administration from Pepperdine University. Working
        together our team serves our local area with four licensed permit holders as well as one CPTED
        (Crime Prevention Through Environmental Design) professional designee as well as multiple
        other team members. This entire team works to provide you the best service and accuracy.</p>
        <br>
        <h2>A few of our Team attributes:</h2>
        <ul>
        <li style="font-size:115%;">Vice President of the Association of Professional Reserve Analysts</li>
        <li style="font-size:115%;">APRA “Professional Reserve Analyst” designee</li>
        <li style="font-size:115%;">Over 10,000 reserve studies conducted.</li>
        <li style="font-size:115%;">Creator and owner of proprietary software and databases used to prepare Complex
        Solutions’ reserve studies. This proprietary software gives Complex Solutions the
        freedom and ability to create reports tailored to the individual client’s needs.</li>
        <li style="font-size:115%;">Projects have ranged in size from small apartment-style condominium communities to
        1000+ Planned Unit Communities.</li>
        <li style="font-size:115%;">Clients have ranged from developers interested in setting initial reserve accounts for
        communities under construction to high-rise communities, worship facilities, day schools
        and more.</li>
        <li style="font-size:115%;">Active member of three local chapters of CAI (Nevada, Utah, and Channel Islands, CA).</li>
        <li style="font-size:115%;">Instructors for the Reserve Study portion of the UNLV community manager pre-
        certification course</li>
        <li style="font-size:115%;">Members of CAMEO (Community Association Management Executive Offices)</li>
        <li style="font-size:115%;">Frequent guest speakers for trade organizations, management companies, and other
        entities</li>
        </ul>
        <br>
        <p style="font-size:120%;">Mr. Forney as well as all our team can be contacted at the number above should you have any
        questions regarding references, work experience, or reserve studies in general.</p>`
    };

    const northernCaliforniaStringObj = {
        text:
            `<h2>Applied Reserve Analysis</h2>
        <p style="font-size:120%;">Since 1992, Applied Reserve Analysis has been providing quality reserve studies to the
        Community Association industry with the highest standard of customer service. By combining
        our commitment to accuracy and professionalism with our impeccable customer service, we
        deliver a level of service unequaled in the industry. We understand the importance of continuity
        and consistency in your reserve budgets and are committed to a long-term business relationship
        with you.</p>
        <br>
        <ul>
        <li style="font-size:115%;">Completed over 10000 reserve studies.</li>
        <li style="font-size:115%;">Projects have ranged in size from small apartment-style condominium communities to
        1000+ Planned Unit Communities, school, houses of worship, and businesses.</li>
        <li style="font-size:115%;">Clients have ranged from developers interested in setting initial reserve accounts for
        communities under construction to high-rise and resort communities.</li>
        <li style="font-size:115%;">Active member of two local chapters of CAI (Bay Area/Central California and Channel
        Islands).</li>
        <li style="font-size:115%;">Professional member of ECHO (Educational Community for Homeowners)</li>
        <li style="font-size:115%;">Member of APRA (Association of Professional Reserve Analysts)</li>
        <li style="font-size:115%;">Our staff includes four Reserve Specialists (RS), a CAI designation, and Professional
        Reserve Analysts (PRA), an APRA designation, a CPTED (crime prevention through
        environmental design) professional deseginee.</li>
        </ul>
        <br>
        <p style="font-size:120%;">Applied Reserve Analysis can be contacted at the number above should you have any questions
        regarding references, work experience, or reserve studies in general. We look forward to
        working with you on your reserve study needs!</p>`
    };

    const southernCaliforniaStringObj = {
        text:
            `<h2>Complex Solutions Ltd.</h2>

        <p style="font-size:120%;">Since 2001, Complex Solutions Ltd. has been providing quality reserve studies to the
        Community Association industry with the highest standard of customer service. By combining
        our commitment to accuracy and professionalism with our impeccable customer service, we
        deliver a level of service unequaled in the industry.</p>
        <br>
        <ul>
        <li style="font-size:115%;">Board member of the Association of Professional Reserve Analysts</li>
        <li style="font-size:115%;">APRA “Professional Reserve Analyst” designee</li>
        <li style="font-size:115%;">Personally has prepared over 1,250 reserve studies.</li>
        <li style="font-size:115%;">Created the proprietary software and databases used to prepare Complex Solutions’
        reserve studies. This proprietary software gives Complex Solutions the freedom and
        ability to create reports tailored to the individual clients needs.</li>
        <li style="font-size:115%;">Projects have ranged in size from small apartment-style condominium communities to
        1000+ Planned Unit Communities, schools, houses of worship and businesses of all
        sizes.</li>
        <li style="font-size:115%;">Clients have ranged from developers interested in setting initial reserve accounts for
        communities under construction to high-rise communities, even an aero park (small
        airport).</li>
        <li style="font-size:115%;">Active member of three local chapters of CAI (Nevada, Utah, and Channel Islands, CA).</li>
        <li style="font-size:115%;">Gold Sponsor of the Nevada chapter of CAI, Platinum Sponsor of the Utah chapter of
        CAI.</li>
        <li style="font-size:115%;">Member of CAMEO (Community Association Management Executive Offices)</li>
        <li style="font-size:115%;">Member of ECHO (Educational Community for Homeowners)</li>
        <li style="font-size:115%;">Our team are frequent speakers at CAI events.</li>
        <li style="font-size:115%;">Multiple contributions and articles published in Community Interests.</li>
        <li style="font-size:115%;">Our staff includes four Reserve Specialists (RS), a CAI designation, and Professional
        Reserve Analysts (PRA), an APRA designation, a CPTED (crime prevention through
        environmental design) professional deseginee.</li>
        </ul>
        <br>
        <p style="font-size:120%;">Complex Solutions, Ltd. can be contacted at the number above should you have any questions
        regarding references, work experience, or reserve studies in general.</p>`
    };

    // Header image
    let headerPath = `/Branding/${orderAssocCompanyBrandKey}/letterheads/bid-letter-header.png`;
    let headerNotFoundPath = `/Branding/${orderAssocCompanyBrandKey}/letterheads/bid-letter-header.png`;

    switch (orderClientStateCode) {
        case OrderCommon.BidLetterStateCodes.Nevada:
            headerPath = `/Branding/${orderAssocCompanyBrandKey}/letterheads/bid-letter-header.png`;
            break;

        default:
            headerPath = `/Branding/${orderAssocCompanyBrandKey}/letterheads/bid-letter-header-other.png`;
            break;
    }

    const headerImageObj = {
        src: ApiEndpoints.getBidLetterUserSignaturePictureUrl(headerPath, false),
        fallbackSrc: ApiEndpoints.getBidLetterUserSignaturePictureUrl(headerNotFoundPath, false),
    };

    // Footer image
    let footerPath = `/Branding/${orderAssocCompanyBrandKey}/letterheads/bid-letter-footer.png`;
    let footerNotFoundPath = `/Branding/${orderAssocCompanyBrandKey}/letterheads/bid-letter-footer.png`;

    switch (orderClientStateCode) {
        case OrderCommon.BidLetterStateCodes.Utah:
            footerPath = `/Branding/${orderAssocCompanyBrandKey}/letterheads/bid-letter-footer-UT.png`;
            break;

        case OrderCommon.BidLetterStateCodes.Nevada:
            footerPath = `/Branding/${orderAssocCompanyBrandKey}/letterheads/bid-letter-footer.png`;
            break;

        case OrderCommon.BidLetterStateCodes.California:
            footerPath = `/Branding/${orderAssocCompanyBrandKey}/letterheads/bid-letter-footer.png`;
            break;

        default:
            footerPath = `/Branding/${orderAssocCompanyBrandKey}/letterheads/bid-letter-footer.png`;
            break;
    }

    const footerImageObj = {
        src: ApiEndpoints.getBidLetterUserSignaturePictureUrl(footerPath, false),
        fallbackSrc: ApiEndpoints.getBidLetterUserSignaturePictureUrl(footerNotFoundPath, false),
    };

    const headerImage = (
        <div>
            <ReactImageFallback
                src={headerImageObj.src}
                fallbackImage={headerImageObj.fallbackSrc}
                className="pdf-order-bid-letter-header-image"
            />
        </div>
    );

    const footerImage = (
        <div className="pdf-order-bid-letter-footer-container">
            <ReactImageFallback
                src={footerImageObj.src}
                fallbackImage={footerImageObj.fallbackSrc}
                className="pdf-order-bid-letter-footer-image"
            />
        </div>
    );

    const southernNevadaResumeText = stringtemplate(Formatters.getStr(southernNevadaStringObj, 'text', 'ERROR'));
    const northernCaliforniaResumeText = stringtemplate(Formatters.getStr(northernCaliforniaStringObj, 'text', 'ERROR'));
    const southernCaliforniaResumeText = stringtemplate(Formatters.getStr(southernCaliforniaStringObj, 'text', 'ERROR'));
    const genericResumeText = stringtemplate(Formatters.getStr(southernCaliforniaStringObj, 'text', 'ERROR'));
    let regionResumeText = '';

    let regionSelector = 0;
    if (orderClientStateCode === OrderCommon.BidLetterStateCodes.Nevada) {
        regionSelector = 1; // Nevada
    } else if (orderClientStateCode === OrderCommon.BidLetterStateCodes.California) {
        if (orderAssocCompanyBrandKey === 'complex-solutions') {
            regionSelector = 4; // Southern California
        } else {
            regionSelector = 2; // Northern California
        }
    } else {
        regionSelector = 3; // Generic
    }

    switch (regionSelector) {
        case 1: // Nevada
            regionResumeText = southernNevadaResumeText;
            break;

        case 2: // Northern California
            regionResumeText = northernCaliforniaResumeText;
            break;

        case 3: // Generic  (Utah, Arizona, etc.)
            regionResumeText = genericResumeText;
            break;

        case 4: // Southern California
            regionResumeText = southernCaliforniaResumeText;
            break;

        default:
            regionResumeText = genericResumeText;
            break;
    }

    const bodyContent = (
        <div className="pdf-order-bid-letter-body-content">
            {<div dangerouslySetInnerHTML={{ __html: regionResumeText }} />}
        </div>);

    return (
        <div>
            <BidLetterReportComponents.ReportPage className="pdf-order-bid-letter-cover-page" reportData={reportData}>
                {headerImage}
                {bodyContent}
                {footerImage}
            </BidLetterReportComponents.ReportPage>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/order/bid-letter/pages/report-page-resumes.tsx